import { useEffect, useRef } from "react";
import { Toast } from "bootstrap";
import { ValidateErrorSVG } from "../../../assets/imageImport";
import { Fragment } from "react";
import { Link } from "react-router-dom";

export const ValidationErrorMessage = ({
  show = false,
  handleHidden,
  message = "",
  title = "Please Note.",
  className = "",
}) => {
  const toastRef = useRef(null);

  useEffect(() => {
    if (toastRef) {
      const toast = new Toast(toastRef.current, { delay: 10000 });
      if (toastRef.current) {
        if (show == true || message != "") {
          toast.show();
        } else if (show == false || message == "") {
          toast.hide();
        }
        toastRef.current.addEventListener("hidden.bs.toast", () => {
          if (handleHidden) handleHidden();
        });
      }
      return () => {
        if (toastRef.current) {
          toastRef.current.removeEventListener("hidden.bs.toast", () => {
            if (handleHidden) handleHidden();
          });
        }
      };
    }
  }, [show, message]);

  return (
    <Fragment>
      <div
        ref={toastRef}
        className={"toast pwdError-toast w-100 mb-3 " + className}
        role="alert"
        aria-live="assertive"
        aria-atomic="true"
      >
        <div className="toast-body fav-orderno-not d-flex align-content-center justify-content-between">
          <div className="fav-ordernoNot-lft d-flex align-items-start justify-content-between">
            <div>
              <ValidateErrorSVG />
            </div>
            <div className="pwd-ordernoNot-info">
              <h5 className="fw-semibold">{title}</h5>
              <p className="fw-medium col-fs-13 fs-14 m-0 w-100">{message}</p>
              {message == "Your account is locked due to too many failed password attempts." ? (
                <Link to="/Forgotpassword">Please Reset Your Password</Link>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className="ct-close">
            <button type="button" className="btn-close" data-bs-dismiss="toast" aria-label="Close" />
          </div>
        </div>
      </div>
    </Fragment>
  );
};
